"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var recompose_1 = require("recompose");
var lodash_1 = require("lodash");
var qs = __importStar(require("qs"));
var fetch_1 = __importDefault(require("../../utils/fetch"));
var cache_1 = require("./cache");
var getItems = function (url, props, params, doPost) { return __awaiter(_this, void 0, void 0, function () {
    var response, queryString, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (url == null) {
                    return [2 /*return*/, []];
                }
                if (!doPost) return [3 /*break*/, 2];
                return [4 /*yield*/, fetch_1.default(url, {
                        method: 'POST',
                        headers: new Headers({ 'Content-Type': 'application/json' }),
                        body: JSON.stringify(params ? params : {}),
                    })];
            case 1:
                response = _a.sent();
                return [3 /*break*/, 4];
            case 2:
                queryString = params
                    ? qs.stringify(params, {
                        allowDots: true,
                        addQueryPrefix: true,
                    })
                    : '';
                return [4 /*yield*/, fetch_1.default(url + queryString)];
            case 3:
                response = _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, response.json()];
            case 5:
                result = _a.sent();
                if (result instanceof Array) {
                    return [2 /*return*/, result];
                }
                else if (result instanceof Object && result.items instanceof Array) {
                    return [2 /*return*/, result.items];
                }
                else {
                    return [2 /*return*/, result];
                }
                return [2 /*return*/];
        }
    });
}); };
/**
 * Creates cache key from url and params.
 *
 * @param {String} url
 * @param {Object} params
 */
var createCacheKey = function (url, params) {
    if (params == null) {
        return url;
    }
    else {
        return url + JSON.stringify(params);
    }
};
/**
 * Compares two params if changed.
 *
 * @param {Object} oldParams
 * @param {Object} params
 */
var paramsChanged = function (oldParams, params) {
    if (oldParams === params) {
        // both the same object or null
        return false;
    }
    else if (oldParams == null || params == null) {
        // one null and other is not
        return true;
    }
    else {
        // compare stringified version of params to do deep equal
        return JSON.stringify(oldParams) !== JSON.stringify(params);
    }
};
var remote = function (component) {
    return recompose_1.compose(recompose_1.pure, recompose_1.defaultProps({
        url: null,
        params: null,
        doPost: false,
        mapItems: lodash_1.identity,
        registerRemote: lodash_1.noop,
        onLoadData: lodash_1.noop,
        getItems: getItems,
        caching: false,
        version: 0,
    }), recompose_1.withStateHandlers({ items: [], loading: false }, {
        startLoading: function (state) { return function () { return ({ items: [], loading: true }); }; },
        setItems: function (state) { return function (items) { return ({ items: items, loading: false }); }; },
    }), recompose_1.lifecycle({
        loadData: function (props) {
            return __awaiter(this, void 0, void 0, function () {
                var url, params, doPost, startLoading, mapItems, getItems_1, setItems, caching, onLoadData, cacheKey, storedItems, result, items, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            url = props.url, params = props.params, doPost = props.doPost, startLoading = props.startLoading, mapItems = props.mapItems, getItems_1 = props.getItems, setItems = props.setItems, caching = props.caching, onLoadData = props.onLoadData;
                            startLoading();
                            cacheKey = createCacheKey(url, params);
                            if (!(caching && url != null)) return [3 /*break*/, 2];
                            return [4 /*yield*/, cache_1.getDataFromCache(cacheKey, true, 60)];
                        case 1:
                            storedItems = _a.sent();
                            if (storedItems !== null) {
                                if (!this.unmounting) {
                                    setItems(storedItems);
                                    return [2 /*return*/];
                                }
                            }
                            _a.label = 2;
                        case 2: return [4 /*yield*/, getItems_1(url, props, params, doPost)];
                        case 3:
                            result = _a.sent();
                            return [4 /*yield*/, mapItems(result)];
                        case 4:
                            items = _a.sent();
                            if (!this.unmounting) {
                                setItems(items);
                                if (caching && url != null) {
                                    cache_1.putDataToCache(cacheKey, items);
                                }
                                onLoadData(items);
                            }
                            return [3 /*break*/, 6];
                        case 5:
                            e_1 = _a.sent();
                            console.log(props.url, e_1.message);
                            return [3 /*break*/, 6];
                        case 6: return [2 /*return*/];
                    }
                });
            });
        },
        componentWillMount: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.props.registerRemote(this.loadData.bind(this), this.props);
                            return [4 /*yield*/, this.loadData(this.props)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        },
        componentWillReceiveProps: function (newProps) {
            return __awaiter(this, void 0, void 0, function () {
                var url, params, version, _a, oldUrl, oldParams, oldVersion;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            url = newProps.url, params = newProps.params, version = newProps.version;
                            _a = this.props, oldUrl = _a.url, oldParams = _a.params, oldVersion = _a.version;
                            if (!(url !== oldUrl || paramsChanged(oldParams, params) || version !== oldVersion)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.loadData(newProps)];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        },
        componentWillUnmount: function () {
            this.unmounting = true;
        },
    }), recompose_1.mapProps(function (_a) {
        var mapItems = _a.mapItems, setItems = _a.setItems, getItems = _a.getItems, url = _a.url, startLoading = _a.startLoading, loading = _a.loading, loadData = _a.loadData, value = _a.value, caching = _a.caching, doPost = _a.doPost, params = _a.params, registerRemote = _a.registerRemote, version = _a.version, rest = __rest(_a, ["mapItems", "setItems", "getItems", "url", "startLoading", "loading", "loadData", "value", "caching", "doPost", "params", "registerRemote", "version"]);
        return __assign({}, rest, { value: loading ? [] : value });
    }))(component);
};
exports.default = remote;
//# sourceMappingURL=remote.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/remote.js
// module id = 198
// module chunks = 0